import { environment } from '../../environments/environment';

export class Urls {
  private static apiAddress = environment.apiUrl;
  private static baseUrl = environment.protocol + environment.apiUrl;

  public static getBaseUrl() {
    return this.baseUrl;
  }

  public static getBaseUrlApi() {
    return this.baseUrl + '/api';
  }

  public static getApiAddress() {
    return Urls.apiAddress;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/url.ts